"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/list-item/list-item");
/**
 * avatar를 leading으로 가지는 표현 전용 행.
 */
let UserItem = class UserItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.size = 'small';
        this.label = '';
        this.description = '';
        this.avatarSrc = '';
        this.avatarVariant = 'primary';
    }
    render() {
        return (0, lit_1.html) `
      <mm-list-item
        size=${this.size}
        label=${this.label}
        description=${this.description}
        icon=${this.icon}
        avatar-variant=${this.avatarVariant}
        avatar-src=${this.avatarSrc}
        avatar-shape="circle"
      >
        <slot name="trailing" slot="trailing"></slot>
      </mm-list-item>
    `;
    }
};
UserItem.styles = [
    (0, lit_1.css) `
      :host {
        display: block;
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], UserItem.prototype, "size", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], UserItem.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], UserItem.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], UserItem.prototype, "icon", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'avatar-src' })
], UserItem.prototype, "avatarSrc", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'avatar-variant' })
], UserItem.prototype, "avatarVariant", void 0);
UserItem = __decorate([
    (0, decorators_js_1.customElement)('mm-user-item')
], UserItem);
exports.UserItem = UserItem;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci1pdGVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidXNlci1pdGVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFLM0QsbURBQWdEO0FBRWhEOztHQUVHO0FBRUksSUFBTSxRQUFRLEdBQWQsTUFBTSxRQUFTLFNBQVEsZ0JBQVU7SUFBakM7O1FBUXVCLFNBQUksR0FBaUIsT0FBTyxDQUFBO1FBQzVCLFVBQUssR0FBRyxFQUFFLENBQUE7UUFDVixnQkFBVyxHQUFHLEVBQUUsQ0FBQTtRQUVTLGNBQVMsR0FBRyxFQUFFLENBQUE7UUFDVixrQkFBYSxHQUFrQixTQUFTLENBQUE7SUFpQm5HLENBQUM7SUFmQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7ZUFFQSxJQUFJLENBQUMsSUFBSTtnQkFDUixJQUFJLENBQUMsS0FBSztzQkFDSixJQUFJLENBQUMsV0FBVztlQUN2QixJQUFJLENBQUMsSUFBSTt5QkFDQyxJQUFJLENBQUMsYUFBYTtxQkFDdEIsSUFBSSxDQUFDLFNBQVM7Ozs7O0tBSzlCLENBQUE7SUFDSCxDQUFDOztBQTVCTSxlQUFNLEdBQUc7SUFDZCxJQUFBLFNBQUcsRUFBQTs7OztLQUlGO0NBQ0YsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7c0NBQTZCO0FBQzVCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzt1Q0FBVztBQUNWO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzs2Q0FBaUI7QUFDaEI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3NDQUFnQjtBQUNVO0lBQXBELElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsU0FBUyxFQUFFLFlBQVksRUFBRSxDQUFDOzJDQUFlO0FBQ1Y7SUFBeEQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsZ0JBQWdCLEVBQUUsQ0FBQzsrQ0FBeUM7QUFidEYsUUFBUTtJQURwQixJQUFBLDZCQUFhLEVBQUMsY0FBYyxDQUFDO0dBQ2pCLFFBQVEsQ0E4QnBCO0FBOUJZLDRCQUFRIn0=